export const GUIDE_SPECIALIZATIONS = [
  'Food Tours',
  'Photography Tours',
  'Adventure Tours',
  'Nature Tours',
  'Temple Tours',
  'Local Culture',
  'Heritage Walks',
  'Wildlife Safari',
  'Trekking',
  'City Tours',
  'Night Tours',
  'Shopping Tours',
] as const;

export const LANGUAGES = [
  'Hindi',
  'English',
  'Tamil',
  'Telugu',
  'Kannada',
  'Malayalam',
  'Bengali',
  'Marathi',
  'Gujarati',
  'Punjabi',
  'Urdu',
  'Odia',
  'Assamese',
  'French',
  'German',
  'Spanish',
  'Japanese',
  'Chinese',
  'Arabic',
  'Russian',
] as const;

export const INDIA_STATES = [
  'Andhra Pradesh',
  'Arunachal Pradesh',
  'Assam',
  'Bihar',
  'Chhattisgarh',
  'Goa',
  'Gujarat',
  'Haryana',
  'Himachal Pradesh',
  'Jharkhand',
  'Karnataka',
  'Kerala',
  'Madhya Pradesh',
  'Maharashtra',
  'Manipur',
  'Meghalaya',
  'Mizoram',
  'Nagaland',
  'Odisha',
  'Punjab',
  'Rajasthan',
  'Sikkim',
  'Tamil Nadu',
  'Telangana',
  'Tripura',
  'Uttar Pradesh',
  'Uttarakhand',
  'West Bengal',
  'Delhi',
  'Jammu & Kashmir',
  'Ladakh',
  'Puducherry',
  'Chandigarh',
] as const;
